import * as React from "react";
import { Route, Switch } from 'react-router-dom';
import LpbEntry from './components/LpbEntry';
import SaleResultsDisplay from './components/saleDisplay/SaleResultsDisplay';

import NoAccess from './components/NoAccess';
import {withAdalLoginApi } from './store/adalConfig';



const LpbEntryProtected = withAdalLoginApi(LpbEntry);
const SaleResultsDisplayProtected = withAdalLoginApi(SaleResultsDisplay);

export default class App extends React.Component {
  //static displayName = App.name;

  render () {
    return (
        <>
            <Switch>
                <Route exact path='/' render={(props) => <LpbEntryProtected {...props}/>} />
                <Route path='/saleResultsDisplay/:saleid/:awex/:roomNo?/:saleDisplayType?/:seller?/:buyer?/:missing/:WD?/:NB?/:Sale?/:Transfer?' render={(props) => <SaleResultsDisplayProtected {...props} />} />
                <Route path='/saleResultsDisplay' render={(props) => <SaleResultsDisplayProtected {...props} />} />
                <Route path='/noaccess' render={(props) => <NoAccess {...props} />} />
            </Switch>
        </>
    );
  }
}